import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CopyRightsText from "./copyright-test/CopyRightsText";
import CustomEmailInput from "./customemail-input/CustomEmailInput";
import s from "./Footer.module.scss";
import RepoStarsForks from "./repostarsforks/RepoStarsForks";
import DownloadAppInfo from "./websitesocial-media/DownloadAppInfo";

const Footer = () => {
  const { t } = useTranslation();
  const section = "footer.section";

  return (
    <footer className={s.footer}>
      <div className="container">
        <section className={s.sections}>
          <section className={s.section1}>
            <b>
              <Link to="/">Exclusive</Link>
            </b>
            <span>{t(`${section}1.subscribe`)}</span>
            <p>{t(`${section}1.getOffer`)}</p>

            <CustomEmailInput />
          </section>

          <section className={s.section2}>
            <b>{t(`${section}2.support`)}</b>

            <ul>
              <li>{t(`${section}2.address`)}</li>
              <li>
                <a href="#">contact@weepoka.com</a>
              </li>
              <li>
                <a href="tel:+0000">+0000</a>
              </li>
            </ul>
          </section>

          <section className={s.section3}>
            <b>{t(`${section}3.account`)}</b>

            <ul>
              <li>
                <Link to="/profile">{t(`${section}3.myAccount`)}</Link>
              </li>
              <li>
                <Link to="/signup">{t(`${section}3.loginRegister`)}</Link>
              </li>
              <li>
                <Link to="/cart">{t(`${section}3.cart`)}</Link>
              </li>
              <li>
                <Link to="/wishlist">{t(`${section}3.wishlist`)}</Link>
              </li>
            </ul>
          </section>

          <section className={s.section4}>
            <b>{t(`${section}4.quickLink`)}</b>

            <ul>
              <li>
                <Link to="/products">{t(`${section}3.shop`)}</Link>
              </li>
              <li>
                <Link to="/terms">{t(`${section}4.termsOfUse`)}</Link>
              </li>

              <li>
                <Link to="/contact">{t(`${section}4.contact`)}</Link>
              </li>
            </ul>
          </section>

          <section className={s.section5}>
            <DownloadAppInfo />
          </section>
        </section>

        <CopyRightsText />
      </div>

      <RepoStarsForks />
    </footer>
  );
};
export default Footer;
